/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.SaleProgram {
    "use strict";

    export class SaleProgramContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        discountTypeEnum: any;

        constructor(
            appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            private $translate: angular.translate.ITranslateService,
            private $sce: ng.ISCEService
        ) {
            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, false);

            this.initializeContext();
            this.initializeSections();

            this.discountTypeEnum = {
                AmountOff: Meevo.Model.DiscountTypeEnum.AmountOff,
                PercentOff: Meevo.Model.DiscountTypeEnum.PercentOff,
                SpecialPrice: Meevo.Model.DiscountTypeEnum.SpecialPrice,
            };
        }

        initializeContext(): void {
            this.entityType = 'SaleProgram';
            this.baseEndpoint = this.appSettings.API_ENDPOINTS.saleProgram;
            this.sectionTemplatePath = "app/plugins/saleProgram/sectionViews/";
            this.buildCrudSecurityKeys(this.securityKeys.REGISTER_SALEPROGRAM);
        }

        initializeSections(): void {

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.REGISTER_SALEPROGRAM_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(
                    0,
                    "SECTION_MAIN",
                    "main.html",
                    true,
                    false,
                    this.appSettings.API_ENDPOINTS.saleProgram,
                    "",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.MarkItemsOnSaleMain,
                    this.securityKeys.REGISTER_SALEPROGRAM_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
                );
            }

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.REGISTER_SALEPROGRAM_TAB_SERVICES + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new ServicesSection(
                    1,
                    "SECTION_SALE_PROGRAM_SERVICES",
                    "services.html",
                    false,
                    false,
                    this.appSettings.API_ENDPOINTS.saleProgram,
                    "",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.MarkItemsOnSaleServices,
                    this.modalService,
                    this.securityKeys.REGISTER_SALEPROGRAM_TAB_SERVICES + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
                );
            }

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.REGISTER_SALEPROGRAM_TAB_PRODUCTS + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new ProductsSection(
                    2,
                    "SECTION_SALE_PROGRAM_PRODUCTS",
                    "products.html",
                    false,
                    false,
                    this.appSettings.API_ENDPOINTS.saleProgram,
                    "",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.MarkItemsOnSaleProducts,
                    this.modalService,
                    this.$translate,
                    this.$sce,
                    this.securityKeys.REGISTER_SALEPROGRAM_TAB_PRODUCTS + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
                );
            }
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
        }

        isDisabled(): boolean {
            return this.isReadonly || !this.isAccessible;
        }

        edit(isUndeleting: boolean = false): void {
            let vm = this;

            // Do not allow CO-owned items to be edited in a location
            if (vm.isCoItemInLocation || vm.isLocationImpersonating) {
                vm.modalService.alert("MESSAGE_CANNOT_EDIT_CO_ITEM", Components.Modal.ModalTranslationModes.Translate);
                return;
            }

            super.edit(isUndeleting);
        }

        selectSection(item): void {
            switch (item.sectionId) {
                case 1:
                    this.buildCrudSecurityKeysBase(this.securityKeys.REGISTER_SALEPROGRAM_TAB_SERVICES, false, false, false);
                    break;
                case 2:
                    this.buildCrudSecurityKeysBase(this.securityKeys.REGISTER_SALEPROGRAM_TAB_PRODUCTS, false, false, false);
                    break;
                default:
                    this.buildCrudSecurityKeysBase(this.securityKeys.REGISTER_SALEPROGRAM, true, false, true, false, true);
                    break;
            }
            super.selectSection(item);
        }
    }
}